import { render } from "./App.vue?vue&type=template&id=7e976dba"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7e976dba&lang=scss"

import exportComponent from "C:\\data\\jenkins_home\\workspace\\VC-AWS-PRODUCTION-FOLDER\\VC-PRODUCTION-VUE-BUILD\\code\\vue\\apps\\benefit-estimator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__